/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bakery_Intro_List_21Inputs */

const en_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open each cake box to discover one of 11 special cakes.`)
};

const ar_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح كل صندوق كعك لتكتشف واحدة من 11 كعكة مميزة.`)
};

const de_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne jede Kuchenbox, um einen von 11 besonderen Kuchen zu entdecken.`)
};

const es_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre cada caja de pasteles para descubrir uno de los 11 pasteles especiales.`)
};

const fr_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrez chaque boîte à gâteaux pour découvrir l'un des 11 gâteaux spéciaux.`)
};

const it_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri ogni scatola di torte per scoprire una delle 11 torte speciali.`)
};

const ja_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケーキボックスを開けて、11種類の特別なケーキの中から1つを見つけましょう。`)
};

const ko_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 케이크 상자를 열어 11가지 특별한 케이크 중 하나를 발견해 보세요.`)
};

const pt_br_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra cada caixa de bolo para descobrir um dos 11 bolos especiais.`)
};

const ru_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте каждую коробку с тортом, чтобы найти один из 11 особенных тортов.`)
};

const th_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดกล่องเค้กแต่ละกล่องเพื่อค้นพบเค้กสุดพิเศษ 1 ใน 11 ชิ้น`)
};

const tr_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11 özel pastadan birini keşfetmek için her pasta kutusunu açın.`)
};

const zh_cn_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开蛋糕礼盒会随机获得 11 款限定蛋糕中的其中一款。`)
};

const zh_tw_bakery_intro_list_21 = /** @type {(inputs: Bakery_Intro_List_21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打開蛋糕禮盒會隨機獲得 11 款限定蛋糕中的其中一款。`)
};

/**
* | output |
* | --- |
* | "Open each cake box to discover one of 11 special cakes." |
*
* @param {Bakery_Intro_List_21Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const bakery_intro_list_21 = /** @type {((inputs?: Bakery_Intro_List_21Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bakery_Intro_List_21Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bakery_intro_list_21(inputs)
	if (locale === "ar") return ar_bakery_intro_list_21(inputs)
	if (locale === "de") return de_bakery_intro_list_21(inputs)
	if (locale === "es") return es_bakery_intro_list_21(inputs)
	if (locale === "fr") return fr_bakery_intro_list_21(inputs)
	if (locale === "it") return it_bakery_intro_list_21(inputs)
	if (locale === "ja") return ja_bakery_intro_list_21(inputs)
	if (locale === "ko") return ko_bakery_intro_list_21(inputs)
	if (locale === "pt_br") return pt_br_bakery_intro_list_21(inputs)
	if (locale === "ru") return ru_bakery_intro_list_21(inputs)
	if (locale === "th") return th_bakery_intro_list_21(inputs)
	if (locale === "tr") return tr_bakery_intro_list_21(inputs)
	if (locale === "zh_cn") return zh_cn_bakery_intro_list_21(inputs)
	return zh_tw_bakery_intro_list_21(inputs)
});
export { bakery_intro_list_21 as "Bakery_intro_list_2" }